import { render, staticRenderFns } from "./visitMChat.vue?vue&type=template&id=1ada6b60&scoped=true"
import script from "./visitMChat.vue?vue&type=script&lang=js"
export * from "./visitMChat.vue?vue&type=script&lang=js"
import style0 from "./visitMChat.vue?vue&type=style&index=0&id=1ada6b60&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ada6b60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ada6b60')) {
      api.createRecord('1ada6b60', component.options)
    } else {
      api.reload('1ada6b60', component.options)
    }
    module.hot.accept("./visitMChat.vue?vue&type=template&id=1ada6b60&scoped=true", function () {
      api.rerender('1ada6b60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/autism/mChat/mChat/visitMChat.vue"
export default component.exports